<div class="component popup-example">
    <h2>Popup</h2>
    <div class="example">
        <button (click)="openCancelablePopup()">Cancelable popup</button>
        <sbw-popup [showPopup]="showCancelablePopup" [closable]="true" (showPopupChange)="cancelPopup()">
            <div>Cancelable popup</div>
        </sbw-popup>
    </div>
    <div class="example">
        <button (click)="openNonCancelablePopup()">Non cancelable popup</button>
        <sbw-popup [showPopup]="showNonCancelablePopup" [closable]="false">
            <div>Non-cancelable popup</div>
            <button (click)="confirmNonCancelablePopup()">Confirm</button>
        </sbw-popup>
    </div>
</div>